import { FeatureName, isFeatureEnabled } from 'owa-feature-flags';

export default function isEUEmailAdsPolicyFeatureEnabled(): boolean {
    // This is a temp shared flight check when we are doing the quick experiment to pick up the best consent layout during the first several weeks.
    // The temp check will be removed after we pick up the best flight.
    const euEmailAdsPolicyFeatures = [
        'fwk-euad-0',
        'fwk-euad-1',
        'fwk-euad-2',
        'fwk-euad-3',
        'fwk-euad-4',
        'fwk-euad-5',
        'fwk-euad-6',
        'fwk-euad-7',
        'fwk-euad-8',
    ];

    const enabledFeature = euEmailAdsPolicyFeatures.filter(feature =>
        isFeatureEnabled(feature as FeatureName)
    );

    return enabledFeature?.length > 0;
}
